import request from '../../../shared/request'

export function getJobNotes(job_id) {
  return request(`/job/notes/${job_id}/`)
}

export function createNote(payload) {
  return request(`/job/notes/${payload.job_id}/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateNote(payload) {
  return request(`/job/notes/${payload.note_id}/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteNote(payload) {
  return request(`/job/notes/${payload.note_id}/`, {
    method: 'DELETE',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

// schedule notes
export function fetchScheduleNote(payload) {
  return request(`/job/schedules/${payload.jobId}/notes`)
}

export function createScheduleNote(payload) {
  return request(`/job/schedules/${payload.jobId}/notes`, {
    method: 'POST',
    body: payload,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function editScheduleNote(payload) {
  return request(`/job/schedules/${payload.noteId}/notes`, {
    method: 'PUT',
    body: payload,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function deleteScheduleNote(payload) {
  return request(`/job/schedules/${payload.noteId}/notes`, {
    method: 'DELETE',
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/job/notes.js